import { connect,no_render} from 'core'
import Chat from 'comp/middle/chat';
import { CONV_TYPE } from 'constants';
import { isNative } from 'core';
import * as selectors from 'selectors';

const mapToProps = state => {
  if (state.ui.tmp_pm && (isNative || state.ui.selected_app_tab === 'PM')) {
    return {
      conv_id: state.ui.selected_pm,
      jumping:state.ui.jump_to_conv,
      messages: [],
      members: {},
      tmp_pm: state.ui.tmp_pm,
      is_last_msg_reached: true,
      is_online: state.system.is_online
    };
  }
  const selected = selectors.getSelectedConv();
  if(!selected){
    return no_render
  }
  const messages = selectors.getMessages(selected.id);
  return {
    jumping:state.ui.jump_to_conv,
    messages,
    members: selectors.nullInPath(state, 'conv', selected.id, 'members'),
    is_online: state.system.is_online,
    conv_id: selected.id,
    is_group: selected.type === CONV_TYPE.GROUP,
    unread_count: selected.total_msg - selected.read_msg,
    last_read_msg_id: selected.last_read_msg_id,
    is_last_msg_reached: messages[0] && messages[0].id === (selected.last_msg && selected.last_msg.id),
    loading_prev: state.ui.loading_prev_messages === selected.id,
    loading_next: state.ui.loading_next_messages === selected.id,
    read_msg: selected.read_msg,
    uploads: state.uploader.chat
  };
};

export default connect(Chat,mapToProps);



// WEBPACK FOOTER //
// ./src/containers/middle/Chat.js